import 'rsuite/dist/rsuite.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { CustomProvider } from 'rsuite';
import { CookiesProvider } from "react-cookie";
import App from './App';
import store from './store';

const rootElement = document.getElementById('root');

ReactDOM.render(
    <CookiesProvider>
        <Provider store={store}>
            <CustomProvider theme="light">
                <App />
            </CustomProvider>
        </Provider>
    </CookiesProvider>, rootElement);
